export class CtaPagar {

    model = {
        id: { value: null, export: false },
        tipo_credito: {
            value: null,
            table: true,
            header: 'Tipo de Crédito:',
            required: 'Seleccione una opción',
        },
        entidad: {
            value: '',
            table: true,
            header: 'Entidad que otorgo el Crédito:',
            required: 'Campo requerido',
            maxLength: 'Máximo 200 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 200,
            min: 3,
        },
        uso_fondos: {
            value: '',
            table: true,
            header: 'Uso de los Fondos:',
            required: 'Campo requerido',
            maxLength: 'Máximo 200 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 200,
            min: 3,
            footer: 'SUBTOTAL:',
        },
        valor: {
            value: 0,
            table: true,
            header: 'Valor Adeudado USD:',
            required: 'Saldo requerido',
            footer: 0,
        },
    }

    optionLabel = 'nombre';
}
